export default "__VITE_ASSET__CTIVAwtD__"